import { render, staticRenderFns } from "./AlertWithErrors.vue?vue&type=template&id=53be1e7a&"
import script from "./AlertWithErrors.vue?vue&type=script&lang=js&"
export * from "./AlertWithErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports